<template>
  <canvas ref="qrCodeDisplay" />
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCode',
  props: {
    value: String
  },
  watch: {
    value: {
      deep: true,
      handler: function() {
        this.updateQRCodeImage()
      }
    }
  },
  mounted() {
    
  },
  methods: {
    updateQRCodeImage() {
      if(this.value && this.value != '') {
        QRCode.toCanvas(this.$refs.qrCodeDisplay, this.value, function (error) {
          if (error) console.error(error)
        })
      }
    }
  }
  
}
</script>